import { useLocation } from "react-router-dom";
import { useUserStore } from "@/common/store";
import { useAgeVerificationStore } from "@/common/store/ageVerificationStore";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { getAgeVerificationStatusFromSearch } from "@/common/utils/ageVerification";
import { isAgeVerificationLocation, isPageAllowed } from "@/common/utils/geoRules";
import { useEffect } from "react";
import { onOpenAgeVerificationPromptPopup } from "@/components/popup-dispatcher/PopupDispatcher";

export const useAgeVerificationPromtPopup = () => {
  const { pathname, search } = useLocation();

  const geoLocation = useGeolocationStore((state) => state.location);
  const currentUser = useUserStore((state) => state.currentUser);
  const ageVerified = useAgeVerificationStore((state) => state.ageVerified);
  const verificationStatus = getAgeVerificationStatusFromSearch(search);

  useEffect(() => {
    if (!geoLocation || !isAgeVerificationLocation(geoLocation)) {
      return;
    }

    if (isPageAllowed(pathname, geoLocation)) {
      return;
    }

    if (!currentUser?.username || ageVerified !== false) {
      return;
    }

    if (verificationStatus) {
      return;
    }

    onOpenAgeVerificationPromptPopup();
  }, [ageVerified, currentUser, geoLocation, pathname, verificationStatus]);
};
